import React, {useState} from "react";
import {FormControl, IconButton, Input, InputAdornment,} from "@mui/material";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export default function DHPasswordFieldSmall({id, label, width, value, disabled, onChange, onKeyDown}) {

    const [showPassword, setShowPassword] = useState(false);

    return <FormControl sx={{ width: width }} variant="filled">
        <Input
            id={id}
            placeholder={label}
            value={value}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
            type={showPassword ? 'text' : 'password'}
            onKeyDown={(e) => {
                if( onKeyDown !== undefined) {
                    onKeyDown(e);
                }
            }}
            endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label={
                            showPassword ? 'hide the password' : 'display the password'
                        }
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                </InputAdornment>
            }
        />
    </FormControl>

}